import {generalRequest} from "@/lib/services/requests";
import {useQuery} from "@tanstack/react-query";

export const useApiSearchAminCourses = (config) => {
    return useQuery({
        queryKey: ['admin', 'course', 'get', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/courses`, config)
        })({params: config})),
    })
}


